import { render, staticRenderFns } from "./BpRevenueNumberDisplayer.vue?vue&type=template&id=5f444b08"
import script from "./BpRevenueNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpRevenueNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports